<template>
  <b-container class="p5-5">
    <b-button
      size="sm"
      class="nuiteq-button mr-2"
      @click="handleClickGetAuth"
      v-if="!isSignIn"
      :disabled="!isInit"
    >Login with Google</b-button>
    <b-button
      size="sm"
      class="nuiteq-button mr-2"
      @click="handleClickSignOut"
      v-if="isSignIn"
      :disabled="!isInit"
    >Logout</b-button>
  </b-container>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      isInit: false,
      isSignIn: false
    };
  },
  methods: {
    handleClickGetAuth() {
      this.$gAuth
        .getAuthCode()
        .then(authCode => {
          return this.$http.post(
            process.env.VUE_APP_BASE_URL + '/' + 'auth/google',
            {
              code: authCode,
              redirect_uri: 'postmessage'
            }
          );
        })
        .then(response => {
          if (response.status === 200) {
            this.$gAuth.isAuthorized = true;
            this.isSignIn = true;
            this.$authenticated.value = true;
            localStorage.setItem('token', response.data.token);
            this.$http.defaults.headers.common['Authorization'] =
              response.data.token;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleClickSignOut() {
      this.$authenticated.value = false;
      localStorage.removeItem('token');
      this.$gAuth
        .signOut()
        .then(() => {
          this.isSignIn = this.$gAuth.isAuthorized;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    let that = this;
    that.isInit;
    let checkGauthLoad = setInterval(function() {
      that.isInit = that.$gAuth.isInit;
      that.isSignIn = that.$authenticated.value;
      if (that.isInit) clearInterval(checkGauthLoad);
    }, 1000);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nuiteq-button {
  width: 100%;
  margin-bottom: 5px;
}
.card-img-top {
  width: 140px;
  margin: auto;
}
.add-card > img:nth-child(1) {
  width: 158px;
}
.card-title {
  text-align: center;
}
.card {
  padding-top: 24px;
  transition: all 0.3s ease;
  border: none;
  border: 1px solid rgba(0, 0, 0, 0);
}
.card:hover {
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.1) 0 0 30px 0;
  border: 1px solid #ef9743;
}
</style>
